<template>
  <div class="relative w-full flex-1 max-w-md">
    <Search
      class="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 dark:text-[#7E8DA5] w-4 h-4 pointer-events-none"
    />
    <input
      type="text"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      placeholder="Search students..."
      class="w-full pl-10 pr-4 py-2 bg-slate-50 dark:bg-[#18243A] border border-slate-200/90 dark:border-[#263449] rounded-xl text-xs sm:text-sm text-slate-900 dark:text-[#F1F5F9] placeholder-slate-400 dark:placeholder-[#7E8DA5] focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:focus:border-indigo-400 transition-all shadow-2xs"
    />
  </div>
</template>

<script setup>
  import { watch } from "vue";
  import { Search } from "lucide-vue-next";

  const props = defineProps({
    modelValue: String,
  });

  const emit = defineEmits(["update:modelValue", "search-text"]);

  // Watch for changes and emit 'search-text' when modelValue changes
  watch(
    () => props.modelValue,
    (newVal) => {
      emit("search-text", newVal);
    }
  );
</script>
